import React from 'react';
import { createRoot } from 'react-dom/client';
import BlogPage from './components/Pages/BlogPage.js';
import DashLooker from './components/Pages/DashLooker.js';

import {
    createBrowserRouter,
    RouterProvider,
  } from "react-router-dom";

import App from './App.js';
import './index.css';


const router = createBrowserRouter([
    {
      path: "/",
      element:<App/>,
    },
    {
      path: "dashboards-tableau-londonbikes",
      element:<BlogPage/>,
    },
    {
      path: "dashboards-looker-sales",
      element:<DashLooker/>,
    }
  ]);
  
const root = createRoot(document.getElementById("root"));

root.render( <RouterProvider router={router} />, document.getElementById('root'));